/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageViewEmodjiDto { 
    /**
     * Условное имя эмоции (например \'::smile::\')
     */
    emodjiName: string | null;
    /**
     * Количество эмоций одного типа
     */
    emodjiCount: number;
    /**
     * Признак действия текущего пользователя
     */
    containsMy: boolean;
}

